<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-4">
        <b-field :label="$t('detailContrat.commentaire.commentaire')"
                 custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.commentaire }}
          </span>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BauxContratDetailCommentaire',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
};
</script>
